/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_Exist_MessageInputs */

const en_not_exist_message = /** @type {(inputs: Not_Exist_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite code not found.`)
};

const ar_not_exist_message = /** @type {(inputs: Not_Exist_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على رمز الدعوة.`)
};

const de_not_exist_message = /** @type {(inputs: Not_Exist_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladungscode nicht gefunden.`)
};

const es_not_exist_message = /** @type {(inputs: Not_Exist_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de invitación no encontrado.`)
};

const fr_not_exist_message = /** @type {(inputs: Not_Exist_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code d’invitation introuvable.`)
};

const it_not_exist_message = /** @type {(inputs: Not_Exist_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice invito non trovato.`)
};

const ja_not_exist_message = /** @type {(inputs: Not_Exist_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待コードが見つかりません。`)
};

const ko_not_exist_message = /** @type {(inputs: Not_Exist_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대 코드를 찾을 수 없어요.`)
};

const pt_br_not_exist_message = /** @type {(inputs: Not_Exist_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de convite não encontrado.`)
};

const ru_not_exist_message = /** @type {(inputs: Not_Exist_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Код приглашения не найден.`)
};

const th_not_exist_message = /** @type {(inputs: Not_Exist_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบรหัสเชิญนี้`)
};

const tr_not_exist_message = /** @type {(inputs: Not_Exist_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet kodu bulunamadı.`)
};

const zh_cn_not_exist_message = /** @type {(inputs: Not_Exist_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`找不到此邀请码。`)
};

const zh_tw_not_exist_message = /** @type {(inputs: Not_Exist_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`找不到此邀請碼。`)
};

/**
* | output |
* | --- |
* | "Invite code not found." |
*
* @param {Not_Exist_MessageInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const not_exist_message = /** @type {((inputs?: Not_Exist_MessageInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_Exist_MessageInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_not_exist_message(inputs)
	if (locale === "ar") return ar_not_exist_message(inputs)
	if (locale === "de") return de_not_exist_message(inputs)
	if (locale === "es") return es_not_exist_message(inputs)
	if (locale === "fr") return fr_not_exist_message(inputs)
	if (locale === "it") return it_not_exist_message(inputs)
	if (locale === "ja") return ja_not_exist_message(inputs)
	if (locale === "ko") return ko_not_exist_message(inputs)
	if (locale === "pt_br") return pt_br_not_exist_message(inputs)
	if (locale === "ru") return ru_not_exist_message(inputs)
	if (locale === "th") return th_not_exist_message(inputs)
	if (locale === "tr") return tr_not_exist_message(inputs)
	if (locale === "zh_cn") return zh_cn_not_exist_message(inputs)
	return zh_tw_not_exist_message(inputs)
});